var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFreccia(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 15,
    viewBox: "0 0 32 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.48645 1.8154C2.37916 1.70811 2.1653 1.53532 2.01501 1.50799C1.9327 1.49303 1.82861 1.40862 1.75378 1.36705C1.68598 1.32939 1.59704 1.30468 1.53507 1.25648C1.38325 1.1384 1.24325 1.05336 1.10859 0.918694C1.0378 0.847912 1.04146 0.762205 1.00409 0.678115C0.970469 0.602465 1.15391 0.612502 1.19607 0.612502",
    stroke: "#A7A7A7",
    strokeWidth: 0.480422,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.17505 0.5L31.2014 3.62274",
    stroke: "#A7A7A7",
    strokeWidth: 0.480422
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2759 3.85132C16.8873 5.52418 10.7588 7.27497 4.85265 12.4989",
    stroke: "#A7A7A7",
    strokeWidth: 0.480422
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.10674 12.2703C4.70783 12.6249 3.91747 13.4601 4.51194 13.9357C4.71717 14.0999 5.28541 13.9002 5.48912 13.8762C5.77178 13.843 6.29798 13.4718 6.55977 13.3409",
    stroke: "#A7A7A7",
    strokeWidth: 0.480422,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreccia);
export default __webpack_public_path__ + "static/media/Freccia.e4cd1f0415220b357ea1c13c9fb71e20.svg";
export { ForwardRef as ReactComponent };